/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TestStepParameterDto = {
    readonly id?: string;
    readonly createdDate?: string;
    readonly createdBy?: string;
    readonly modifiedDate?: string;
    readonly modifiedBy?: string;
    readonly version?: number;
    type: TestStepParameterDto.type;
    sheetId: string;
    mbSpecificationId: string;
    active: boolean;
};
export namespace TestStepParameterDto {
    export enum type {
        BOOLEAN = 'BOOLEAN',
        STRING = 'STRING',
        SELECTION = 'SELECTION',
        DATE = 'DATE',
        LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
        LESS_THAN = 'LESS_THAN',
        GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL',
        GREATER_THAN = 'GREATER_THAN',
        EXACT_VALUE = 'EXACT_VALUE',
        MIN_MAX_RANGE = 'MIN_MAX_RANGE',
        GREATER_THAN_OR_EQUAL_AND_LESS_THAN_RANGE = 'GREATER_THAN_OR_EQUAL_AND_LESS_THAN_RANGE',
        GREATER_THAN_AND_LESS_THAN_OR_EQUALS_RANGE = 'GREATER_THAN_AND_LESS_THAN_OR_EQUALS_RANGE',
        RATE_REPORT = 'RATE_REPORT',
    }
}

